import React from 'react';
export function Footer() {
  return <footer className="bg-green-950/60 text-white py-12 px-4 text-center border-t border-green-700/20" data-id="element-92">
      <div className="max-w-4xl mx-auto" data-id="element-93">
        <p className="text-white/50 font-medium mb-4" data-id="element-94">
          © 2026 GuíaDigital360™
        </p>
        <p className="text-xl font-bold text-white mb-6" data-id="element-95">
          Método Venta Flash IA
        </p>
        <div className="flex items-center justify-center gap-4 text-sm text-white/50" data-id="element-96">
          <a href="#" className="hover:text-white transition-colors" data-id="element-97">
            Términos
          </a>
          <span data-id="element-98">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-99">
            Privacidad
          </a>
          <span data-id="element-100">·</span>
          <a href="mailto:soporteguiadigital360@gmail.com" className="hover:text-white transition-colors" data-id="element-101">
            Soporte
          </a>
        </div>
      </div>
    </footer>;
}